import { defineChain } from 'viem'

export const CHAIN_ID: number = {
  localhost: 1337,
  mainnet: 1,
}[process.env.NEXT_PUBLIC_CHAIN_SELECTOR ?? 'mainnet'] as number

export const CHAIN_EXPLORER_URL = 'https://etherscan.io'

export const hyperliquid = defineChain({
  blockExplorers: {
    default: {
      name: 'Purrsec',
      url: 'https://purrsec.com/',
    },
  },
  caipNetworkId: 'eip155:999',
  chainNamespace: 'eip155',
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11' as `0x${string}`,
      blockCreated: 13051,
    },
  },
  id: 999,
  name: 'Hyperliquid',
  nativeCurrency: { decimals: 18, name: 'HYPE', symbol: 'HYPE' },
  rpcUrls: {
    default: {
      http: ['https://rpc.hyperliquid.xyz/evm'],
      webSocket: ['wss://hyperliquid.drpc.org'],
    },
  },
  testnet: false,
})

export enum ChainStrings {
  ETHEREUM = 'ethereum',
  APTOS = 'aptos',
  ARBITRUM = 'arbitrum',
  BLAST = 'blast',
  MANTLE = 'mantle',
  MODE = 'mode',
  SOLANA = 'solana',
  DERIVE = 'derive',
  MANTA = 'manta',
  KINTO = 'kinto',
  SCROLL = 'scroll',
  MOVEMENT = 'movement',
  TON = 'ton',
  HYPEREVM = 'hyperevm',
}
